import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getUserPracticeById } from "../api";
import AccountList from "../Components/Accounts/AccountList";
import AgedInvoicesList from "../Components/Accounts/InvoiceList";
import TransactionList from "../Components/Accounts/TransactionList";
import ClaimList from "../Components/Accounts/ClaimList";
import OzowList from "../Components/Accounts/OzowList";
import ERAList from "../Components/Accounts/ERAList";
import AllocationReport from "../Components/Accounts/AllocationReport";
import { useLocation } from "react-router-dom";

function Billing() {
  const [practice, setPractice] = useState([]);
  const [activeSection, setActiveSection] = useState("account");
  const [hoveredSection, setHoveredSection] = useState(null);
  const [userRole, setUserRole] = useState(false);
  const location = useLocation();

  // sections config
  const sidebarItems = useMemo(
    () => [
      { key: "account", label: "Account List" },
      { key: "invoices", label: "Open Invoices", gated: true },
      { key: "transactions", label: "Sales Report", gated: true },
      { key: "allocations", label: "Allocation Report", gated: true },
      { key: "claims", label: "Claims", gated: true },
      { key: "eras", label: "Electronic Remittance Advices", gated: true },
     // { key: "payments", label: "Ozow Payments", gated: true },
    ],
    []
  );

  // URL param awareness
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("aging")) setActiveSection("invoices");
    if (params.get("paymentStatus")) setActiveSection("payments");
    if (params.get("claims")) setActiveSection("claims");
    if (params.get("eras")) setActiveSection("eras");
  }, [location.search]);

  // load user + roles
  useEffect(() => {
    async function getData() {
      try {
        const token = sessionStorage.getItem("user");
        if (!token) return;

        const user = jwtDecode(token);

        const rolesFromRole = Array.isArray(user?.role)
          ? user.role
          : user?.role
          ? [user.role]
          : [];
        const rolesFromPermissions = Array.isArray(user?.permissions)
          ? user.permissions
          : [];
        const roles = [...new Set([...rolesFromRole, ...rolesFromPermissions])];
        const allowedRoles = ["Finance", "SuperAdmin"];
        const hasAllowedRole = roles.some((r) => allowedRoles.includes(r));
        setUserRole(hasAllowedRole);

        const fetchedPractices = await getUserPracticeById(user._id);
        setPractice(Array.isArray(fetchedPractices) ? fetchedPractices : []);
      } catch (err) {
        console.error("⛔ Error fetching practices/roles:", err);
        setPractice([]);
        setUserRole(false);
      }
    }
    getData();
  }, []);

  // render header

  // render content
  function renderContent() {
    switch (activeSection) {
      case "account":
        return <AccountList />;
      case "invoices":
        return <AgedInvoicesList />;
      case "transactions":
        return <TransactionList />;
      case "allocations":
        return <AllocationReport />;
      case "claims":
        return <ClaimList />;
     case "eras":
        return <ERAList />;
   //   case "payments":
      //     return <OzowList />;
      default:
        return <AccountList />;
    }
  }

  return (
    <div className="ms-1" style={{ marginTop: "75px" }}>
      {/*  {renderHeader()} */}

      <Container fluid>
        <Row className="g-0">
          {/* LEFT PANEL */}
          <Col md={2} className="pt-1 g-0">
            <Container className="bg-white vh-100 g-0 p-3 shadow-sm rounded">
              <div className="text-center mb-3 mt-1">
                {sidebarItems.map((item) => {
                  if (item.gated && !userRole) return null; // hide if no role
                  return (
                    <div
                      key={item.key}
                      onMouseEnter={() => item.children && setHoveredSection(item.key)}
                      onMouseLeave={() => item.children && setHoveredSection(null)}
                    >
                      <Button
                        variant={activeSection === item.key ? "primary" : "outline-primary"}
                        className="w-100 text-start mb-1"
                        onClick={() => setActiveSection(item.key)}
                      >
                        {item.label}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </Container>
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={10}>
            <Container className="pt-3 bg-transparent pb-3 mb-3 rounded">
              {renderContent()}
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Billing;
